import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDQJWsKCfE1HOCO6SYLCBsXNapZHLYoq8s",
  authDomain: "clone-reactjs-bfa42.firebaseapp.com",
  databaseURL: "https://clone-reactjs-bfa42.firebaseio.com",
  projectId: "clone-reactjs-bfa42",
  storageBucket: "clone-reactjs-bfa42.appspot.com",
  messagingSenderId: "564693451518",
  appId: "1:564693451518:web:b6ad8c05bf49ecee241baf",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };